import { useEffect } from 'react';
import { bwLinkClickTracking } from '../analytics';

export const useBWLinkClickTracking = () => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!(e.target instanceof Element)) return;
      const anchor = e.target.closest('a');
      if (anchor?.href) {
        bwLinkClickTracking({
          href: anchor.href,
          linkText: anchor.textContent?.trim() || '',
          pagePath: window.location.pathname,
        });
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
};
